import routes from './routes'
import * as links from './links'
import * as components from './components'
import * as actions from './actions'
import * as types from './actionTypes'
//import * as containers from './containers'
import reducer from './reducer'

export default {
  actions,
  types,
  reducer,
  //containers,
  components,
  links,
  routes
}



// WEBPACK FOOTER //
// ./src/features/Hotel/index.js